import { Horario24, Time24 } from "../../../../utils/Horario24";

const Horarios = ({ form, setForm }: any) => {

  const onChange = (e: any) => {
    switch (e.target.name) {
      case "start_date":
        {
          setForm({
            ...form,
            start_date: e.target.value,
          });
        }
        break;
      case "type_time":
      case "regular_time":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "duration":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any) => {
    switch (e.target.name) {
      case "date":
        {
          /*
          setForm({
            ...form,
            start_date: time.start_date,
          });
          */
        }
        break;
      case "time":
        {
          /*
          setForm({
            ...form,
            type_time: time.type_time,
            regular_time: time.regular_time,
          });
          */
        }
        break;
      case "duration":
        {
          /*
          setForm({
            ...form,
            duration: duration.duration,
          });
          */
        }
        break;
    }
  };

  console.log(form);
  
  return (
    <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          Especifícanos los horarios
        </span>
        <div className="grid grid-cols-1 gap-5">
          <span></span>

          <div className="border px-5 py-3 shadow-xl border border-black rounded-xl">
            <span>Fecha de inicio</span>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Fecha
              </div>
              <input
                type="date"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 0px 0px" }}
                value={form.start_date}
                name="start_date"
                onChange={(e) => onChange(e)}
              />
            </div>
          </div>

          <div className="border px-5 py-3 shadow-xl border border-black rounded-xl">
            <span>Horario regular de inicio</span>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Hora de inicio
              </div>
              <select
                id="countries"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 0px 0px" }}
                name="regular_time"
                onChange={(e) => onChange(e)}
              >
                <option selected></option>
                {Horario24().map((h) => (
                  <option value={h}>{h}</option>
                ))}
              </select>
            </div>
            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Hora de finalización
              </div>
              <select
                id="countries" 
                className="pt-5 w-full"
                style={{ borderRadius: "0px 0px 10px 10px" }}
                name="type_time"
                onChange={(e) => onChange(e)}
              >
                <option selected></option>
                <option value="flexible">Flexible</option>
                <option value="Sin finalizacion">Sin finalizacion</option>
              </select>
            </div>

            <div className="hidden flex justify-between mt-5 border border-b-0 border-s-0 border-e-0 border-black w-100 py-2">
              <label className="hidden text-gray p-0 cursor-pinter">
                <span className="border border-s-0 border-t-0 border-e-0 border">
                  Cancelar
                </span>
                <button className="hidden" name=""></button>
              </label>

              <label className="bg-primary text-white px-5 py-2 rounded-md cursor-pointer">
                Guardar
                <button
                  className="hidden"
                  name="time"
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>
          </div>

          <div className="border px-5 py-3 shadow-xl border border-black rounded-xl">
            <span>Duracion aproximada</span>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              ></div>
              <select
                id="countries"
                className="pt-5 w-full"
                style={{ borderRadius: "0px 0px 10px 10px" }}
                name="duration"
                onChange={(e) => onChange(e)}
              >
                <option selected></option>
                {Time24().map((time) => (
                  <option value={time}>{time} horas</option>
                ))}
              </select>
            </div>

            <div className="hidden flex justify-between mt-5 border border-b-0 border-s-0 border-e-0 border-black w-100 py-2">
              <label className="hidden text-gray p-0 cursor-pinter">
                <span className=" border border-s-0 border-t-0 border-e-0 border">
                  Cancelar
                </span>
                <button className="hidden"></button>
              </label>

              <label className="bg-primary text-white px-5 py-2 rounded-md cursor-pointer">
                Guardar
                <button
                  className="hidden"
                  name="duration"
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Horarios;
